import React, { useState } from "react";
import {
	Card,
	CardContent,
	Typography,
	Box,
	Button,
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
	IconButton,
	TextField,
	Input,
	Grid,
} from "@material-ui/core";
import {
	Plus as AddIcon,
	Trash2 as DeleteIcon,
	Upload as UploadIcon,
} from "react-feather";

interface GeneralItem {
	id: string;
	text: string;
}

export const GeneralInfoTab = () => {
	const [items, setItems] = useState<GeneralItem[]>([]);
	const [newItemText, setNewItemText] = useState("");
	const [referenceImage, setReferenceImage] = useState<File | null>(null);
	const [imagePreview, setImagePreview] = useState<string | null>(null);

	const addItem = () => {
		if (newItemText.trim()) {
			const newItem: GeneralItem = {
				id: Date.now().toString(),
				text: newItemText.trim(),
			};
			setItems([...items, newItem]);
			setNewItemText("");
		}
	};

	const deleteItem = (id: string) => {
		setItems(items.filter(item => item.id !== id));
	};

	const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (file) {
			setReferenceImage(file);
			const reader = new FileReader();
			reader.onload = (e) => {
				setImagePreview(e.target?.result as string);
			};
			reader.readAsDataURL(file);
		}
	};

	const removeImage = () => {
		setReferenceImage(null);
		setImagePreview(null);
	};

	return (
		<Card>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Información General
				</Typography>
				
				{/* Items Section */}
				<Box mb={3}>
					<Typography variant="subtitle1" gutterBottom>
						Items de Información
					</Typography>
					
					<Grid container spacing={2} alignItems="center" style={{ marginBottom: 16 }}>
						<Grid item xs={9}>
							<TextField
								fullWidth
								variant="outlined"
								size="small"
								placeholder="Agregar nuevo item..."
								value={newItemText}
								onChange={(e) => setNewItemText(e.target.value)}
								onKeyPress={(e) => {
									if (e.key === 'Enter') {
										addItem();
									}
								}}
							/>
						</Grid>
						<Grid item xs={3}>
							<Button
								variant="contained"
								color="primary"
								startIcon={<AddIcon />}
								onClick={addItem}
								fullWidth
								disabled={!newItemText.trim()}
							>
								Agregar
							</Button>
						</Grid>
					</Grid>

					<List>
						{items.map((item, index) => (
							<ListItem key={item.id} divider={index < items.length - 1}>
								<ListItemText primary={item.text} />
								<ListItemSecondaryAction>
									<IconButton
										edge="end"
										onClick={() => deleteItem(item.id)}
										color="secondary"
									>
										<DeleteIcon />
									</IconButton>
								</ListItemSecondaryAction>
							</ListItem>
						))}
					</List>

					{items.length === 0 && (
						<Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: 16 }}>
							No hay items agregados
						</Typography>
					)}
				</Box>

				{/* Image Section */}
				<Box>
					<Typography variant="subtitle1" gutterBottom>
						Imagen de Referencia
					</Typography>
					
					{!imagePreview ? (
						<Box
							border="2px dashed #ccc"
							borderRadius={4}
							p={3}
							textAlign="center"
							style={{ cursor: 'pointer' }}
						>
							<input
								accept="image/*"
								style={{ display: 'none' }}
								id="image-upload"
								type="file"
								onChange={handleImageUpload}
							/>
							<label htmlFor="image-upload">
								<Button
									variant="outlined"
									component="span"
									startIcon={<UploadIcon />}
								>
									Subir Imagen
								</Button>
							</label>
							<Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
								Formatos soportados: JPG, PNG, GIF
							</Typography>
						</Box>
					) : (
						<Box>
							<img
								src={imagePreview}
								alt="Imagen de referencia"
								style={{
									maxWidth: '100%',
									maxHeight: 200,
									borderRadius: 4,
									border: '1px solid #ddd'
								}}
							/>
							<Box mt={1}>
								<Button
									variant="outlined"
									color="secondary"
									onClick={removeImage}
									size="small"
								>
									Remover Imagen
								</Button>
							</Box>
						</Box>
					)}
				</Box>
			</CardContent>
		</Card>
	);
};